import {
  type ILoanSubledgerRow,
  LOAN_SERVICING_OPTIONS,
  LOAN_SUBLEDGER_STATUSES,
} from '../WarehouseLines/types'

const statusOptions = LOAN_SUBLEDGER_STATUSES.reduce(
  (acc, status) => ({ ...acc, [status]: status }),
  {} as Record<string, string>,
)

const servicingOptions = LOAN_SERVICING_OPTIONS.reduce(
  (acc, option) => ({ ...acc, [option]: option }),
  {} as Record<string, string>,
)

export const loanSubledgerInputs = (
  form: Partial<ILoanSubledgerRow>,
  warehouseLineOptions: Record<string, string>,
): Record<string, any> => ({
  loanId: { inputType: 'text', title: 'Loan ID', value: form.loanId, required: true },
  borrower: { inputType: 'text', title: 'Borrower', value: form.borrower },
  product: { inputType: 'text', title: 'Product', value: form.product },
  noteRate: { inputType: 'text', type: 'number', title: 'Note Rate (%)', value: form.noteRate },
  fundedAmount: { inputType: 'text', type: 'number', title: 'Funded Amount', value: form.fundedAmount },
  invAccountNo: { inputType: 'text', title: 'Inv. Acct', value: form.invAccountNo },
  status: {
    inputType: 'select',
    title: 'Status',
    options: statusOptions,
    value: form.status || 'Held',
    hasDefaultOption: false,
    required: true,
  },
  warehouseLine: {
    inputType: 'select',
    title: 'Warehouse Line',
    options: warehouseLineOptions,
    value: form.warehouseLine,
    hasDefaultOption: true,
    defaultOptionText: 'Select',
  },
  investor: { inputType: 'text', title: 'Investor', value: form.investor },
  salePrice: { inputType: 'text', type: 'number', title: 'Sale Price', value: form.salePrice },
  escrowBalance: { inputType: 'text', type: 'number', title: 'Escrow Bal.', value: form.escrowBalance },
  fundedDate: { inputType: 'text', type: 'date', title: 'Funded Date', value: form.fundedDate },
  servicing: {
    inputType: 'select',
    title: 'Servicing',
    options: servicingOptions,
    value: form.servicing,
    hasDefaultOption: false,
  },
  msrValue: { inputType: 'text', type: 'number', title: 'MSR Value', value: form.msrValue },
})
